// Curated list — covers ~95% of typical agency inquiries.
// Format: { code: ISO-2, name, dial: dial code without +, flag emoji }
export const COUNTRIES = [
  { code: "NL", name: "Netherlands", dial: "31", flag: "🇳🇱" },
  { code: "US", name: "United States", dial: "1", flag: "🇺🇸" },
  { code: "GB", name: "United Kingdom", dial: "44", flag: "🇬🇧" },
  { code: "FR", name: "France", dial: "33", flag: "🇫🇷" },
  { code: "DE", name: "Germany", dial: "49", flag: "🇩🇪" },
  { code: "IT", name: "Italy", dial: "39", flag: "🇮🇹" },
  { code: "ES", name: "Spain", dial: "34", flag: "🇪🇸" },
  { code: "BE", name: "Belgium", dial: "32", flag: "🇧🇪" },
  { code: "CH", name: "Switzerland", dial: "41", flag: "🇨🇭" },
  { code: "AT", name: "Austria", dial: "43", flag: "🇦🇹" },
  { code: "DK", name: "Denmark", dial: "45", flag: "🇩🇰" },
  { code: "SE", name: "Sweden", dial: "46", flag: "🇸🇪" },
  { code: "NO", name: "Norway", dial: "47", flag: "🇳🇴" },
  { code: "FI", name: "Finland", dial: "358", flag: "🇫🇮" },
  { code: "IE", name: "Ireland", dial: "353", flag: "🇮🇪" },
  { code: "PT", name: "Portugal", dial: "351", flag: "🇵🇹" },
  { code: "PL", name: "Poland", dial: "48", flag: "🇵🇱" },
  { code: "CZ", name: "Czech Republic", dial: "420", flag: "🇨🇿" },
  { code: "GR", name: "Greece", dial: "30", flag: "🇬🇷" },
  { code: "RO", name: "Romania", dial: "40", flag: "🇷🇴" },
  { code: "HU", name: "Hungary", dial: "36", flag: "🇭🇺" },
  { code: "TR", name: "Türkiye", dial: "90", flag: "🇹🇷" },
  { code: "RU", name: "Russia", dial: "7", flag: "🇷🇺" },
  { code: "UA", name: "Ukraine", dial: "380", flag: "🇺🇦" },
  { code: "CA", name: "Canada", dial: "1", flag: "🇨🇦" },
  { code: "MX", name: "Mexico", dial: "52", flag: "🇲🇽" },
  { code: "BR", name: "Brazil", dial: "55", flag: "🇧🇷" },
  { code: "AR", name: "Argentina", dial: "54", flag: "🇦🇷" },
  { code: "CL", name: "Chile", dial: "56", flag: "🇨🇱" },
  { code: "CO", name: "Colombia", dial: "57", flag: "🇨🇴" },
  { code: "AU", name: "Australia", dial: "61", flag: "🇦🇺" },
  { code: "NZ", name: "New Zealand", dial: "64", flag: "🇳🇿" },
  { code: "JP", name: "Japan", dial: "81", flag: "🇯🇵" },
  { code: "KR", name: "South Korea", dial: "82", flag: "🇰🇷" },
  { code: "CN", name: "China", dial: "86", flag: "🇨🇳" },
  { code: "TW", name: "Taiwan", dial: "886", flag: "🇹🇼" },
  { code: "HK", name: "Hong Kong", dial: "852", flag: "🇭🇰" },
  { code: "SG", name: "Singapore", dial: "65", flag: "🇸🇬" },
  { code: "TH", name: "Thailand", dial: "66", flag: "🇹🇭" },
  { code: "ID", name: "Indonesia", dial: "62", flag: "🇮🇩" },
  { code: "PH", name: "Philippines", dial: "63", flag: "🇵🇭" },
  { code: "VN", name: "Vietnam", dial: "84", flag: "🇻🇳" },
  { code: "MY", name: "Malaysia", dial: "60", flag: "🇲🇾" },
  { code: "IN", name: "India", dial: "91", flag: "🇮🇳" },
  { code: "PK", name: "Pakistan", dial: "92", flag: "🇵🇰" },
  { code: "BD", name: "Bangladesh", dial: "880", flag: "🇧🇩" },
  { code: "AE", name: "UAE", dial: "971", flag: "🇦🇪" },
  { code: "SA", name: "Saudi Arabia", dial: "966", flag: "🇸🇦" },
  { code: "QA", name: "Qatar", dial: "974", flag: "🇶🇦" },
  { code: "IL", name: "Israel", dial: "972", flag: "🇮🇱" },
  { code: "EG", name: "Egypt", dial: "20", flag: "🇪🇬" },
  { code: "MA", name: "Morocco", dial: "212", flag: "🇲🇦" },
  { code: "ZA", name: "South Africa", dial: "27", flag: "🇿🇦" },
  { code: "NG", name: "Nigeria", dial: "234", flag: "🇳🇬" },
  { code: "KE", name: "Kenya", dial: "254", flag: "🇰🇪" },
];
